import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCatalogPanelLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.99076 3.89729C4.97547 2.84115 6.37768 2.25 8.03313 2.25H16.4678C18.1272 2.25 19.5296 2.84086 20.5134 3.89773C21.4916 4.94853 22 6.39899 22 8.02638V15.9736C22 17.601 21.4916 19.0515 20.5133 20.1023C19.5293 21.1592 18.1266 21.75 16.4669 21.75H8.03313C6.37379 21.75 4.97117 21.1592 3.98714 20.1024C3.00872 19.0516 2.5 17.6011 2.5 15.9736V8.02638C2.5 6.39795 3.01147 4.9476 3.99076 3.89729ZM5.08786 4.9202C4.41042 5.64678 4 6.70962 4 8.02638V15.9736C4 17.2913 4.40879 18.354 5.08492 19.0802C5.75542 19.8003 6.74437 20.25 8.03313 20.25H16.4669C17.7562 20.25 18.7451 19.8002 19.4154 19.0802C20.0914 18.3541 20.5 17.2914 20.5 15.9736V8.02638C20.5 6.70857 20.0914 5.64585 19.4155 4.91976C18.7452 4.19973 17.7566 3.75 16.4678 3.75H8.03313C6.74924 3.75 5.75988 4.19944 5.08786 4.9202Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.38867 2.25C9.80289 2.25 10.1387 2.58579 10.1387 3V21C10.1387 21.4142 9.80289 21.75 9.38867 21.75C8.97446 21.75 8.63867 21.4142 8.63867 21V3C8.63867 2.58579 8.97446 2.25 9.38867 2.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.25 8.25C3.25 7.83579 3.58579 7.5 4 7.5H9.38867C9.80289 7.5 10.1387 7.83579 10.1387 8.25C10.1387 8.66421 9.80289 9 9.38867 9H4C3.58579 9 3.25 8.66421 3.25 8.25Z",
			fill: "currentColor"
		})
	]
});
export default SvgCatalogPanelLine;
